import React from "react";
import CustomEvent from "core/customEvent/index";
import PropTypes from "prop-types";
import pubsub from "core/global/global";
import store from "core/store/";
import ShowDICOM from "core/DICOMtag";
import ReactGA from "react-ga";
/// Button UI
import SVGIconLabelButton from "component/atoms/SVGIconLabelButton/SVGIconLabelButton";
import SVGIcons from "assets/icon";
import { observer } from "mobx-react";

// import RootStore from "pages/demo-dashboard/modules/store/rootStore";
import { inject } from "mobx-react";
import { reaction } from "mobx";

import "./ControlPanel.css";


@inject("sarcopeniaMeasureStore")
@observer
class ControlPanel extends React.Component {
  
  
  componentDidMount() {
    // this.disposeReaction = reaction(
    //   () => this.props.sarcopeniaMeasureStore.getCheckedColorCount(),
    //   (checkedCount, prevCount) => {
    //     // 비활성화 로직 추가 예시
    //     if (checkedCount !== 1) {
    //       this.changeActiveDCMViewerTool("BrowseSeries");
    //       pubsub.publish(CustomEvent.Messages.SET_ACTIVE_TOOLBAR_BUTTON, {
    //         id: "Pen",
    //         active: false,
    //       });
  
    //       pubsub.publish(CustomEvent.Messages.SET_ACTIVE_TOOLBAR_BUTTON, {
    //         id: "erase",
    //         active: false,
    //       });
    //     }
    //   }
    // );
    document.addEventListener("keydown", this.handleKeyDown);

  }
  componentWillUnmount() {
    if (this.disposeReaction) {
      this.disposeReaction();
    }
    document.removeEventListener("keydown", this.handleKeyDown);
  }


  handleKeyDown = (e) => {
    if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === "z") {
      this.props.sarcopeniaMeasureStore.applyMaskFromUndoStack(); // 위에서 정의한 함수
      e.preventDefault();
    }
  };


  /**
   * @method 
   * @param toolname  도구 이름
   * @description DCMViewerTool에 입력 파라미터 값으로 활성화 도구 변경 메세지를 보낸다
   * @memberof ToolbarSection
   */
  changeActiveDCMViewerTool = (toolname) => {
    store.SelectedMeasure.setSelectedMeasure("");
    pubsub.publish(CustomEvent.Messages.SET_ACTIVE_TOOL, toolname);
  };

  /**
   * @method handlePanButtonClick
   * @description Pan 버튼 클릭 이벤트 발생시 실행되는 이벤트 핸들러
   * DCMViewer에서 활성화 도구를 Pan으로 변경한다.
   * @memberof ToolbarSection
   */
  handlePanButtonClick = (event, isActive) => {
    if (isActive) {
      this.changeActiveDCMViewerTool("Pan");
      ReactGA.event({
        category: "DICOM Viewer Tool",
        action: "activate Pan DICOM Viewer Tool",
      });
    } else {
      this.changeActiveDCMViewerTool("BrowseSeries");
      ReactGA.event({
        category: "DICOM Viewer Tool",
        action: "deactivate Pan DICOM Viewer Tool",
      });
    }
  };

  /**
   * @method handleZoomButtonClick
   * @description Zoom 버튼 클릭 이벤트 발생시 실행되는 이벤트 핸들러
   * DCMViewer에서 활성화 도구를 Zoom으로 변경한다.
   * @memberof ToolbarSection
   */
  handleZoomButtonClick = (event, isActive) => {
    if (isActive) {
      this.changeActiveDCMViewerTool("Zoom");
      ReactGA.event({
        category: "DICOM Viewer Tool",
        action: "activate Zoom DICOM Viewer Tool",
      });
    } else {
      this.changeActiveDCMViewerTool("BrowseSeries");
      ReactGA.event({
        category: "DICOM Viewer Tool",
        action: "deactivate Zoom DICOM Viewer Tool",
      });
    }
  };

  /**
   * @method handleContrastButtonClick
   * @description Contrast 버튼 클릭 이벤트 발생시 실행되는 이벤트 핸들러
   * DCMViewer에서 활성화 도구를 Contrast으로 변경한다.
   * @memberof ToolbarSection
   */
  handleContrastButtonClick = (event, isActive) => {
    if (isActive) {
      this.changeActiveDCMViewerTool("Contrast");
      ReactGA.event({
        category: "DICOM Viewer Tool",
        action: "activate Contrast DICOM Viewer Tool",
      });
    } else {
      this.changeActiveDCMViewerTool("BrowseSeries");
      ReactGA.event({
        category: "DICOM Viewer Tool",
        action: "deactivate Contrast DICOM Viewer Tool",
      });
    }
  };

  handleAnnotationToggleClick = (event, isActive) => {
    ShowDICOM.toggleIsShowDICOMTag();
    const showTag = ShowDICOM.getIsShowDICOMTag();
    if (showTag === true) {
      ReactGA.event({
        category: "DICOM Viewer Tool",
        action: "activate Tag display",
      });
    } else {
      ReactGA.event({
        category: "DICOM Viewer Tool",
        action: "deactivate Tag display",
      });
    }
    pubsub.publish(CustomEvent.Messages.TOGGLE_DICOM_TAG, {});
    this.changeActiveDCMViewerTool("BrowseSeries");
  };
  
  handlePenButtonClick = (event, isActive) => {
    // const visibleMap = this.props.sarcopeniaMeasureStore._visibleMap_3Cls;
  
    // // 사용할 key들만 뽑음
    // const keys = ["BODY", "MUSCLE", "FAT"];
    // // true인 체크박스 갯수 셈
    // const checkedKeys = keys.filter(key => visibleMap[key]);
    
    // if (checkedKeys.length > 1) {
    //   alert("색상은 1개만 선택할 수 있습니다.");
    //   return;
    // }
    // if (checkedKeys.length === 0) {
    //   alert("색상을 하나 이상 선택해야 그릴 수 있습니다.");
    //   return;
    // }
  
    // // 체크된 키(체크된 한 가지)가 뭔지 확인 (예: SFat 등)
    // const selectedLabel = checkedKeys[0];
    // console.log("[선택된 라벨]: ", selectedLabel);
    // // 색상 매핑 예시 (프로젝트에 따라 달라질 수 있음)
    // const colorMap = {
    //   BODY: "#FF008A",
    //   MUSCLE: "#00A9FF",
    //   FAT: "#4BFF00",
    // };
    // const color = colorMap[selectedLabel];
    const color = "#4BFF00";
    const toolname = "Pencil";
    const toolData = {toolName: toolname, color: color};
    if (isActive) {
      this.changeActiveDCMViewerTool(toolData);
      ReactGA.event({
        category: "DICOM Viewer Tool",
        action: "activate Pen DICOM Viewer Tool",
      });
    } else {
      this.changeActiveDCMViewerTool("BrowseSeries");
      ReactGA.event({
        category: "DICOM Viewer Tool",
        action: "deactivate Pen DICOM Viewer Tool",
      });
    }
  };

  handleEraseButtonClick = (event, isActive) => {
    if (isActive) {
      this.changeActiveDCMViewerTool("Erase");
      ReactGA.event({
        category: "DICOM Viewer Tool",
        action: "activate Erase DICOM Viewer Tool",
      });
    } else {
      this.changeActiveDCMViewerTool("BrowseSeries");
      ReactGA.event({
        category: "DICOM Viewer Tool",
        action: "deactivate Erase DICOM Viewer Tool",
      });
    }
  };

  render() {
    const {
      isEditMode,
      _measureDatalist,
      getCheckedColorCount,
      setMode,
    } = this.props.sarcopeniaMeasureStore;
  
    // Edit 모드가 아닐 때 Pen / Erase 활성화 조건
    // const isPenOrEraseDisabled = !isEditMode || getCheckedColorCount() !== 1;
    const isPenOrEraseDisabled = !isEditMode
  
    // Edit 모드 진입 제한 로직
    const handleToggleClick = (e) => {
      const willToggleToEdit = !isEditMode;
  
      if (willToggleToEdit && _measureDatalist.length === 0) {
        e.preventDefault();
        return;
        // alert("측정 데이터가 존재하지 않아 Edit 모드로 sweetalert2 수 없습니다.");
        
      } else {
        setMode(willToggleToEdit ? "edit" : "view");
      }
    };
  
    return (
      <div className="control-item">
        {/* Control 제목 + 모드 토글 스위치 */}
        <label
          className="item-title"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <span>Control</span>
  
          <div className="switch-container">
            <span className="switch-label">
              {isEditMode ? "VIEW" : "EDIT"}
            </span>
            <label className="switch">
              <input
                type="checkbox"
                checked={isEditMode}
                onClick={handleToggleClick}
                onChange={() => {}} // ❌ 상태 중복 방지용 (의도적으로 비워둠)
              />
              <span className="slider" />
            </label>
          </div>
        </label>
  
        {/* 툴 버튼 영역 */}
        <div className="item-panel">
          <div className="tool-panel">
            <SVGIconLabelButton
              id="pan"
              identifier="pan"
              label="Pan"
              tooltip="Pan"
              isToggleButton
              svgComponentIcon={SVGIcons.SVGPan2Icon}
              svgActiveIcon={SVGIcons.SVGPan2ActiveIcon}
              onButtonClick={this.handlePanButtonClick}
            />
            <SVGIconLabelButton
              id="zoom"
              identifier="zoom"
              label="Zoom"
              tooltip="Zoom"
              isToggleButton
              svgComponentIcon={SVGIcons.SVGZoom2Icon}
              svgActiveIcon={SVGIcons.SVGZoom2ActiveIcon}
              onButtonClick={this.handleZoomButtonClick}
            />
            <SVGIconLabelButton
              id="contrast"
              identifier="contrast"
              label="Contrast"
              tooltip="Contrast"
              isToggleButton
              svgComponentIcon={SVGIcons.SVGContrast2Icon}
              svgActiveIcon={SVGIcons.SVGContrast2ActiveIcon}
              onButtonClick={this.handleContrastButtonClick}
            />
            <SVGIconLabelButton
              id="text"
              identifier="text"
              label="Text"
              tooltip="Text"
              isToggleButton
              svgComponentIcon={SVGIcons.SVGTextIcon}
              svgActiveIcon={SVGIcons.SVGTextActiveIcon}
              onButtonClick={this.handleAnnotationToggleClick}
            />
            <SVGIconLabelButton
              id="Pen"
              identifier="pen"
              label="Pen"
              tooltip="Pen"
              isToggleButton
              disabled={isPenOrEraseDisabled}
              svgComponentIcon={
                isPenOrEraseDisabled
                  ? SVGIcons.SVGPen2ViewIcon
                  : SVGIcons.SVGPen2Icon}
              svgActiveIcon={SVGIcons.SVGPen2ActiveIcon}
              onButtonClick={this.handlePenButtonClick}
            />
            <SVGIconLabelButton
              id="erase"
              identifier="erase"
              label="Eraser"
              tooltip="Erase"
              isToggleButton
              disabled={isPenOrEraseDisabled}
              svgComponentIcon={
                isPenOrEraseDisabled
                  ? SVGIcons.SVGErase2ViewIcon
                  : SVGIcons.SVGErase2Icon}
              svgActiveIcon={SVGIcons.SVGErase2ActiveIcon}
              onButtonClick={this.handleEraseButtonClick}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default observer(ControlPanel);
